<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<template>
  <footer>
    <nav>
      <RouterLink class="home" :to="{ name: 'home' }">
        <img
          src="../assets/home-active.svg"
          v-if="route.name === 'home' || route.name.indexOf('move-container') > -1"
        />
        <img src="../assets/home.svg" v-else />
      </RouterLink>
      <RouterLink class="weighing" :to="{ name: 'weigh-container-scan' }">
        <img
          src="../assets/weighing-active.svg"
          v-if="route.name.indexOf('weigh-container') > -1"
        />
        <img src="../assets/weighing.svg" v-else />
      </RouterLink>
      <RouterLink class="add-container" :to="{ name: 'add-container' }">
        <img
          src="../assets/add-container-active.svg"
          v-if="route.name.indexOf('add-container') > -1"
        />
        <img src="../assets/add-container.svg" v-else />
      </RouterLink>
    </nav>
  </footer>
</template>

<style scoped lang="scss">
footer {
  background-color: #f0f4f7;
  position: relative;

  nav {
    height: 100%;
    padding: 0 7.5%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
      display: block;
      width: 5.5dvh;
      height: 5.5dvh;

      &.home {
        width: 7.5dvh;
        height: 7.5dvh;
        position: absolute;
        top: 0%;
        left: 50%;
        transform: translate(-50%, -35%);
      }

      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
